import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useDispatch } from "react-redux";
import { deletePartner } from "../../../redux/CustomerReducer";
// import Swal from "sweetalert2";
import Swal from "sweetalert2";
import { getUsers, verifyAmbassador } from "../../../redux/CustomerReducer";
// import './UserDataAdmin.css'
//import { getAmbassadors } from "../../../redux/CustomerReducer";
import { RiDeleteBin6Line } from "react-icons/ri";

import { useState } from "react";
import { useEffect } from "react";

import { useSelector } from "react-redux";
import EditAmbassadorDrawer from "../EditAmbassadorDrawer/EditAmbassadorDrawer";


export default function FoundersVerifiedData(props) {
  const [deleteVeh, setDeleteVeh] = useState(0);
const[Index,setIndex]=useState();
const[flag,setFlag]=useState();
  const dispatch = useDispatch();
  const [alertIndex, setAlertIndex] = useState();
  
  let yy=props.driverData;
  console.log("yy:",yy);
  const filtered = yy?.filter((item) => item.verified===true && item.verifieduser === true && item.category === "founder");
  
    console.log("filtered",filtered)
  

  return (
    <div>
<TableContainer component={Paper}>
  <table className="admin-table">
    <thead>
      <tr>
        <th>
          Name
        </th>
        <th>
          Title
        </th>
        <th>
          Email
        </th>
        <th>
          Location
        </th>
        <th>
          Twitter
        </th>
        <th>
          LinkedIn
        </th>
        <th>
          Phone
        </th>
      </tr>
    </thead>
    <tbody>
      {filtered?.map((row, index) => (
        <tr key={row?.fullName}>
          <td className="admin-table-strong">
            {row?.fullName}
          </td>
          <td>
            <div className="">{row?.title}</div>
          </td>
          <td>
            {row?.email}
          </td>
          <td>
            {row?.location}
          </td>
          <td>
            <a href={row?.twitter} className="text-blue-500 hover:underline transition-colors duration-300" target="_blank" rel="noopener noreferrer">
              Link here
            </a>
          </td>
          <td>
            <a href={row?.linkedIn} className="text-blue-500 hover:underline transition-colors duration-300" target="_blank" rel="noopener noreferrer">
              Link here
            </a>
          </td>
          <td>
            {row?.phone}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</TableContainer>
    </div>
  );
}
